export interface ISectorEconomico {
  id?: number;
  nombre?: string | null;
}

export class SectorEconomico implements ISectorEconomico {
  constructor(public id?: number, public nombre?: string | null) {}
}
